import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';

export enum FUEL_FEATURE_FLAGS {
  FUEL_TANK_LEVEL_ENABLED = 'fuel-tank-level-enabled',
  FUEL_SCORE_TABLEAU_REPORT_ENABLED = 'fuel-score-tableau-report-enabled',
  FUEL_SCORE_HIDE_SCORE_ENABLED = 'fuel-score-hide-score-enabled',
  FUEL_IFTA_REARCH_ENABLED = 'fuel-ifta-rearch-enabled',
  FUEL_EV_BATTERY_VISIBILITY_ENABLED = 'fuel-ev-battery-visibility-enabled',
  FUEL_EV_ALERTS_ENABLED = 'fuel-ev-alerts-enabled',
  FUEL_MX_CURRENCY_ENABLED = 'fuel-mx-currency-enabled',
  FUEL_PTO_ON_OFF_SPLIT_ENABLED = 'fuel-pto-on-off-split-enabled',
  FUEL_EV_ENERGY_USAGE_REPORT_ENABLED = 'fuel-ev-energy-usage-report-enabled',
  FUEL_DRIVER_COMPANY_ID_ENABLED = 'fuel-driver-company-id-enabled',
  FUEL_CAN_PTO_AUX_3_ENABLED = 'fuel-can-pto-aux-3-enabled',
  FUEL_CAN_PTO_PHASE_3_ENABLED = 'fuel-can-pto-aux-3-phase-3-enabled',
  FUEL_VEHICLE_FUEL_PERFORMANCE_REPORT_GROUP_ID_ENABLED = 'fuel-vehicle-fuel-performance-report-group-id-enabled',
  FUEL_DRIVER_FUEL_PERFORMANCE_REPORT_GROUP_ID_ENABLED = 'fuel-driver-fuel-performance-report-group-id-enabled',
  FUEL_SHOW_FUEL_TAB_SIDEBAR = 'fuel-show-fuel-tab-sidebar',
}

@Injectable({ providedIn: 'root' })
export class FuelFeatureFlagService {
  constructor(private statsigService: StatsigService) { }

  public isFuelTankLevelEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FUEL_FEATURE_FLAGS.FUEL_TANK_LEVEL_ENABLED);
  }

  public isFuelScoreTableauReportEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FUEL_FEATURE_FLAGS.FUEL_SCORE_TABLEAU_REPORT_ENABLED);
  }

  public isFuelScoreHideScoreEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FUEL_FEATURE_FLAGS.FUEL_SCORE_HIDE_SCORE_ENABLED);
  }

  public isIftaRearchEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FUEL_FEATURE_FLAGS.FUEL_IFTA_REARCH_ENABLED);
  }

  public isFuelEVBatteryVisibilityEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FUEL_FEATURE_FLAGS.FUEL_EV_BATTERY_VISIBILITY_ENABLED);
  }

  public isFuelEVAlertsEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_EV_ALERTS_ENABLED);
  }

  public isFuelMXCurrencyEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_MX_CURRENCY_ENABLED);
  }

  public isPtoOnOffSplitEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_PTO_ON_OFF_SPLIT_ENABLED);
  }

  public isFuelEVEnergyUsageReportEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_EV_ENERGY_USAGE_REPORT_ENABLED);
  }

  public isFuelDriverCompanyIdEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_DRIVER_COMPANY_ID_ENABLED);
  }

  public isFuelCanPtoAux3Enabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_CAN_PTO_AUX_3_ENABLED);
  }

  public isFuelCanPtoPhase3Enabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_CAN_PTO_PHASE_3_ENABLED);
  }

  public isFuelVehicleFuelPerformanceReportGroupIdEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_VEHICLE_FUEL_PERFORMANCE_REPORT_GROUP_ID_ENABLED);
  }

  public isFuelDriverFuelPerformanceReportGroupIdEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_DRIVER_FUEL_PERFORMANCE_REPORT_GROUP_ID_ENABLED);
  }

  public isFuelShowTabSidebarEnabled(): boolean {
    return this.statsigService.evaluateGate(FUEL_FEATURE_FLAGS.FUEL_SHOW_FUEL_TAB_SIDEBAR);
  }
}
